/** Semantic categorical palette used by the current Sleep stage track. */
export const SLEEP_STAGE_COLORS: Readonly<Record<string, string>> = Object.freeze({
  Wake: "#dff1ee", N1: "#b7ded8", N2: "#48a99f", N3: "#123b61", REM: "#7f5aa8",
  Unknown: "#d8e0e2", Missing: "#d8e0e2", Unscored: "#e7ecee",
});
